/**
 * 封闭图标集（ui-spec §3.4）：只允许下面登记的线性图标，24 网格、1.75 描边、圆角端点。
 * 页面不得内联 SVG / Emoji / 字符图标。
 */
export const iconNames = [
  'home',
  'server',
  'users',
  'globe',
  'arrow',
  'lock',
  'box',
  'activity',
  'settings',
  'menu',
  'sun',
  'moon',
  'search',
  'brand',
  'plus',
  'more',
  'copy',
  'download',
  'qr',
  'check',
  'alert',
  'info',
  'x',
  'pause',
  'key',
  'shield',
  'refresh',
  'terminal',
] as const;

export type IconName = (typeof iconNames)[number];

/** 每个图标由若干 path d 组成（全部使用 currentColor、无填充）。 */
export const iconPaths: Record<IconName, readonly string[]> = {
  home: ['M3 10.5 12 3l9 7.5V21H3z', 'M9 21v-7h6v7'],
  server: ['M3 4.5h18v6H3z', 'M3 13.5h18v6H3z', 'M6.5 7.5h.01', 'M6.5 16.5h.01'],
  users: [
    'M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z',
    'M2.5 20c0-3.6 2.9-6.5 6.5-6.5s6.5 2.9 6.5 6.5',
    'M16 4.5a3.5 3.5 0 0 1 0 7',
    'M17.5 13.7c2.3.8 4 3 4 5.5',
  ],
  globe: [
    'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z',
    'M3 12h18',
    'M12 3c2.5 2.4 4 5.6 4 9s-1.5 6.6-4 9c-2.5-2.4-4-5.6-4-9s1.5-6.6 4-9z',
  ],
  arrow: ['M5 12h14', 'M13 6l6 6-6 6'],
  lock: ['M5 10.5h14v10H5z', 'M8 10.5V7a4 4 0 0 1 8 0v3.5'],
  box: ['M21 8 12 3 3 8v8l9 5 9-5z', 'M3 8l9 5 9-5', 'M12 13v8'],
  activity: ['M3 12h4l3-7 4 14 3-7h4'],
  settings: [
    'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
    'M19.4 15a1.7 1.7 0 0 0 .3 1.9l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.9-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.9.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.9 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.9l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.9.3 1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.9-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.9 1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z',
  ],
  plus: ['M12 5v14', 'M5 12h14'],
  menu: ['M4 7h16', 'M4 12h16', 'M4 17h16'],
  sun: [
    'M12 16.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9z',
    'M12 2v2',
    'M12 20v2',
    'M4.9 4.9l1.4 1.4',
    'M17.7 17.7l1.4 1.4',
    'M2 12h2',
    'M20 12h2',
    'M4.9 19.1l1.4-1.4',
    'M17.7 6.3l1.4-1.4',
  ],
  moon: ['M20.5 14.2A8.5 8.5 0 0 1 9.8 3.5a8.5 8.5 0 1 0 10.7 10.7z'],
  search: ['M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14z', 'M16.2 16.2 20.5 20.5'],
  brand: ['M3.5 5.5h17v13h-17z', 'M7.5 9.5l2 2-2 2', 'M12.5 13.5h4'],
  more: ['M5.5 12h.01', 'M12 12h.01', 'M18.5 12h.01'],
  copy: ['M9 9h11v11H9z', 'M5 15H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1'],
  download: ['M12 3v12', 'M7 10l5 5 5-5', 'M4 19h16'],
  qr: [
    'M3 3h6v6H3z',
    'M15 3h6v6h-6z',
    'M3 15h6v6H3z',
    'M15 15h2v2h-2z',
    'M19 15h2v2h-2z',
    'M15 19h2v2h-2z',
    'M19 19h2v2h-2z',
  ],
  check: ['M4 12.5 9 17.5 20 6.5'],
  alert: ['M12 3.5 22 20H2z', 'M12 9.5v4.5', 'M12 17.2h.01'],
  info: ['M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z', 'M12 11v5', 'M12 7.8h.01'],
  x: ['M5 5l14 14', 'M19 5 5 19'],
  pause: ['M9 5v14', 'M15 5v14'],
  key: ['M8 19a4 4 0 1 0 0-8 4 4 0 0 0 0 8z', 'M10.8 12.2 20.5 2.5', 'M17 6l2 2', 'M14.5 8.5l2 2'],
  shield: ['M12 3l8 3v6c0 4.5-3.1 7.7-8 9-4.9-1.3-8-4.5-8-9V6z'],
  refresh: ['M20.5 12a8.5 8.5 0 1 1-2.6-6.1', 'M20.5 3.5V9H15'],
  terminal: ['M4 6.5 9.5 12 4 17.5', 'M12 17.5h8'],
};
